module.exports = __webpack_public_path__ + "img/neoparent-logo.e0347071.png";